import { NgIf, NgClass } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation, forwardRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Note } from 'app/models/document';
import { Util } from 'app/models/util';
import { EventService } from 'app/services/event.service';
import { NoteService } from 'app/services/note.service';
import { NgxLoadingModule } from 'ngx-loading';
import { QuillEditorComponent } from 'ngx-quill';
import { ToastrService } from 'ngx-toastr';
import { IsDisplayedDirective } from '@fuse/directives/isDisplayed.directive';

@Component({
    selector     : 'modal-edit-item-note',
    templateUrl  : './edit-item-note.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [
        MatButtonModule, 
        MatIconModule, 
        FormsModule, 
        ReactiveFormsModule,
         MatFormFieldModule, 
         MatInputModule, 
         NgIf,
         NgClass,
         QuillEditorComponent,
         MatProgressSpinnerModule,
         NgxLoadingModule,
         forwardRef(() => IsDisplayedDirective)
        ],
})
export class EditItemNoteComponent implements OnInit 
{
    editItemNoteForm: UntypedFormGroup;
    isLoading = false;
    note : Note = new Note();

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<EditItemNoteComponent>,
        private _formBuilder: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public noteServ : NoteService,
        public toastr : ToastrService,
        public eventService : EventService,
        public util : Util

    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        if (this.data?.note) {
            this.note = this.data.note;
        }
    }

    /**
     * Discard the action
     */
    cancel(): void {
        // Close the dialog
        this.matDialogRef.close();
    }

    public getEditorToolbar() {
		return this.util.getEditorToolbarOptions();
	}

    /**
     * Submits the form data and adds a note.
     */
    submit(){
        this.isLoading = true;
        //this.note.comment =  this.util.removeHtmlTags(this.note.comment);
        this.noteServ.addNote(this.note, this.data.docId).then((res)=>{
            this.toastr.info("Note saved successfully");
            this.cancel();
            this.isLoading = false;
            this.eventService.getGlobalData.emit('note');

        }).catch((error)=>{
            this.isLoading = false;
            console.log(error);
        })
     }

}
